import { CategoriesStorage, TabCategory } from '../../documents';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map, publishReplay, refCount } from 'rxjs/operators';
import { UrlBuilder } from '../../core';
import { SponsorRouteData } from '../sponsor-route-data';
import { Category } from '../../documents/models/category';
import { SponsorStudy } from '../../sponsor-dashboard/sponsor-study';
import { UserPermissions } from '../../user-permissions/user-permissions';

@Component({
    selector: 'sponsor-activity-reports',
    template: require('./../../shared/tabs.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorActivityReportsComponent implements OnInit {
    public tabsCategories: Observable<TabCategory[]>;

    constructor(
        private readonly routeData: SponsorRouteData,
        private readonly urlBuilder: UrlBuilder,
        private readonly categoriesStorage: CategoriesStorage
    ) {}

    public ngOnInit() {
        this.tabsCategories = this.createTabs();
    }

    private createTabs(): Observable<TabCategory[]> {
        const study$ = this.routeData.selectedStudy;
        const studyUserPermissions$ = this.routeData.studyPermissions;
        const categories$ = this.categoriesStorage.activityReportCategories;

        return combineLatest(
            study$,
            categories$,
            studyUserPermissions$
        )
        .pipe(
            map(([study, categories, studyUserPermissions]) => {
                const tabs: TabCategory[] = [];

                this.appendDocumentsTab(tabs, study, categories, studyUserPermissions);
                this.appendProtocolAccessTab(tabs, study, studyUserPermissions);
                this.appendEReqReportsTab(tabs, study, studyUserPermissions);
                return tabs;
            }),
            publishReplay(1),
            refCount()
        );
    }

    private appendDocumentsTab(tabs: TabCategory[], study: SponsorStudy, categories: Category[], studyUserPermissions: UserPermissions) {
        const isAllowedSomeCategory = categories.some(c => studyUserPermissions.canViewActivityReport(c.categoryId));

        if (isAllowedSomeCategory) {
            const documentsTab: TabCategory = {
                name: 'Documents',
                url: this.urlBuilder
                    .esa()
                    .sponsor()
                    .study(study)
                    .activityReports()
                    .documents()
                    .url()
            };

            tabs.push(documentsTab);
        }
    }

    private appendProtocolAccessTab(tabs: TabCategory[], study: SponsorStudy, studyUserPermissions: UserPermissions) {
        const hasAccess = studyUserPermissions.has('ViewActivityReportProtocolAccess');

        if (hasAccess) {
            const protocolAccess: TabCategory = {
                name: 'Protocol Access',
                url: this.urlBuilder
                    .esa()
                    .sponsor()
                    .study(study)
                    .activityReports()
                    .protocolAccess()
                    .url()
            };

            tabs.push(protocolAccess);
        }
    }

    private appendEReqReportsTab(tabs: TabCategory[], study: SponsorStudy, studyUserPermissions: UserPermissions) {
        const eReqReports: TabCategory = {
            name: 'eRequisition',
            url: this.urlBuilder
                .esa()
                .sponsor()
                .study(study)
                .activityReports()
                .eReqReports()
                .url()
        };

        tabs.push(eReqReports);
    }
}
